export default __webpack_public_path__ + "static/media/Gauntlets of the Usurper.5b95b5ca.jpg";